import './App.css';
import {
  Navigate,
  RouteObject,
  useRoutes
} from "react-router-dom";
import ApplicationAppService from './application/platform/application-app-service';
import { IndexFactory } from './presentation/login/login-factory';
import { PageNotFound } from './presentation/page-not-found';
import { PageUnauthorized } from './presentation/page-unauthorized';
import { EnvioRemessaFactory } from './presentation/publication-shipment/envio-remessa/envio-remessa-factory';
import { DashboardFactory } from './presentation/publication-shipment/dahsboard/dashboard-factory';
import { ConsultaRemessaFactory } from './presentation/publication-shipment/consulta-remessa/consutla-remessa-factory';
import { ProfielFactory } from './presentation/profile/profile-factory';
import { PublicacaoDiarioOficial } from './presentation/official-daily/publicacao-diario-oficial/publicacao-diario-oficial';
import { PublicacaoDiarioOficialFactory } from './presentation/official-daily/publicacao-diario-oficial/publicacao-diario-oficial-factory';
import { ConsultaDiarioOficialFactory } from './presentation/official-daily/consulta-diario-oficial/consulta-diario-oficial-factory';
import { DetalhesDiarioOficial } from './presentation/official-daily/detalhes-diario-oficial/detalhes-diario-oficial';
import { DetalhesDiarioOficialFactory } from './presentation/official-daily/detalhes-diario-oficial/detalhes-diario-oficial-factory';
import { CadastroBasico } from './presentation/admin-portal/cadastros-basico/cadastro-basico';
import { FORM_TYPES } from './presentation/admin-portal/cadastros-basico/context/cadastros-basico-reducer';
import { CadastroBasicoFactory } from './presentation/admin-portal/cadastros-basico/cadastro-basico-factory';
import ClientsManagementFactory from './presentation/clients/clients-management/clients-management-factory';

// const authenticationData = ApplicationAppService.getAuthenticationData();
const applicationData = ApplicationAppService.getApplicationData();

// const ProtectedRoute = ({ children }: { children: any }) => {

//   if (!authenticationData) {

// console.log(authenticationData);
//     return <Navigate to="/unauthorized" replace />;
//   }

//   return children;
// };

const routeSERP = (): RouteObject[] => {
  var routes: RouteObject[] = [
    {
      path: "/dashboard", element: <DashboardFactory/>
    },
    {
      path: "/envio-remessa", element: <EnvioRemessaFactory/>
    },
    {
      path: "/consulta-remessa/:publicationShipmentId?", element: <ConsultaRemessaFactory/>
    },
  ];
  return routes;
}

const routeSPDO = (): RouteObject[] => {
  var routes: RouteObject[] = [
    {
      path: "/dashboard", element: <DashboardFactory/>
    },
      {
      path: "/clientes", element: <ClientsManagementFactory/>
    },
    {
      path: "/diagramar-diario-oficial/:publicationShipmentId?", element: <PublicacaoDiarioOficialFactory/>
    },
    {
      path: "/consulta-remessa/:publicationShipmentId?", element: <ConsultaRemessaFactory/>
    },

    {
      path: "/consulta-diario-oficial", element: <ConsultaDiarioOficialFactory/>
    },
    {
      path: "/detalhes-diario-oficial/:officialDailyId", element: <DetalhesDiarioOficialFactory/>
    },
  ];
  return routes;
}

const routeSGAP = (): RouteObject[] => {
  var routes: RouteObject[] = [
    {
      path: "/dashboard", element: <DashboardFactory/>
    },
    {
      path: "/categoria-noticias/:id?", element: <CadastroBasicoFactory formType={FORM_TYPES.categoriesNews}/>
    },
    {
      path: "/noticias/:id?", element: <CadastroBasicoFactory formType={FORM_TYPES.news}/>
    },
    {
      path: "/link-servicos/:id?", element: <CadastroBasicoFactory formType={FORM_TYPES.linkServices}/>
    },
    {
      path: "/banners/:id?", element: <CadastroBasicoFactory formType={FORM_TYPES.banners}/>
    },
    {
      path: "/estrutura-governamental/:id?", element: <CadastroBasicoFactory formType={FORM_TYPES.estruturaGovernametal}/>
    }
  ];
  return routes;
}

const defaultRoutes = (): RouteObject[] => {
  var routes: RouteObject[] = [
    {
      path: "*", element: <PageNotFound></PageNotFound>
    },
    {
      path: "/index.html", element: <IndexFactory />
    },   
    {
      path: "/perfil", element: <ProfielFactory />
    },
    {
      path: "/", element: <IndexFactory />
    },
    {
      path: "/unauthorized", element: <PageUnauthorized></PageUnauthorized>
    },
  ];

  return routes;
}

const createRoutesModules = (): RouteObject[] => {
  var routes = defaultRoutes(); 
   if (applicationData.moduleId === 1) {
    routes.push(...routeSERP());
   }else if (applicationData.moduleId === 2) {
    routes.push(...routeSPDO());
  } else if (applicationData.moduleId === 3) {
    routes.push(...routeSGAP());
  }
  return routes;
}

const App = () => {
  let routes = useRoutes(
    createRoutesModules()
  );
  return routes;
}



export default App;
